import {useEffect, useId, useState} from "react";
import {CheckIcon, SearchIcon, ThinCloseIcon} from "../../../components/icons/material-icons";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {ShowSnackbar} from "../../../components/template/snackbar";

interface salaryPeopleInterface {
    id: number,
    price: number,
    bank: string,
    name: string,
    img: string,
    selected: boolean,
}

export const AdminsStaffCreateSalaryModal = (props: { active: boolean, closeHandler: any,onDone:any }) => {
    const [list, setList] = useState<salaryPeopleInterface[]>([]);
    const [title, setTitle] = useState('');
    const titleId = useId();
    const [titleErr, setTitleErr] = useState(false);
    const [level, setLevel] = useState('staff' as 'staff' | 'title');
    const fetchStaff = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/salary/get-staff',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                list: salaryPeopleInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setList(d.list === null ? [] : d.list);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            fetchStaff();
            setTitle('');
            setTitleErr(false);
            setLevel('staff');
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = () => {
        const _title = title.trim();
        let final:{staff:number,price:number}[] = [];
        if(_title.length < 2){
            setTitleErr(true);
            return;
        }
        const _list = [...list];
        let finalTxt = "";
        _list.forEach(e=>{
           if(e.selected) {
               final.push({
                   staff: e.id,
                   price: e.price,
               });
               if(finalTxt !== "")
                   finalTxt += "\r\n";
               finalTxt += e.bank + "," + (e.price * 10) + "," + _title;
           }
        });
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/salary/create',
            {
                title:_title,
                items:JSON.stringify(final),
            },
            true,
            (d: {
                result: string,
                reason: string,
                count:number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                var a = encodeURI('data:text/plain;charset=UTF-8,\uFEFF' + finalTxt);
                var link = document.createElement('a');
                link.setAttribute('href', a);
                link.setAttribute('download', _title+'.txt');
                document.body.appendChild(link);
                link.click();
                ShowSnackbar(
                    'فایل خروجی واریزی دانلود شد.',
                    'باشه',
                    5000,
                );
                props.closeHandler();
                props.onDone();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const [search, setSearch] = useState('');
    useEffect(() => {
        if (level !== 'staff')
            return;
        const filter = search.toUpperCase();
        const lst = document.querySelector('.reports--select-employee-buttons298');
        const btns = (lst as HTMLDivElement).getElementsByTagName('button');
        for (let i = 0; i < btns.length; i++) {
            const b = btns[i].getElementsByTagName('span')[0];
            const v = b.innerHTML.toUpperCase();
            if (v.indexOf(filter) > -1)
                btns[i].style.display = "";
            else
                btns[i].style.display = "none";
        }
    }, [search]);
    const isAllChecked = () => {
        const lst = [...list];
        let isAllChecked = true;
        lst.forEach(e => {
            if (!e.selected)
                isAllChecked = false;
        });
        return isAllChecked;
    };
    const getTotal = (lst: salaryPeopleInterface[]) => {
        let total = 0;
        lst.forEach(e => {
            if (e.selected)
                total += e.price;
        });
        return total;
    };
    const getSelectedCount = (lst: salaryPeopleInterface[]) => {
        let total = 0;
        lst.forEach(e => {
            if (e.selected)
                total += 1;
        });
        return total;
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top:20}}>
                <div className="web-modal-header">
                    <div><b>ایجاد واریزی حقوق</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    {

                        level === 'title' ?
                            <>
                                <div className="add-student">
                                    <label>هزینه کل:</label>
                                    <span style={{
                                        display: 'block',
                                        margin: '5px 0 0 0',
                                        fontWeight: 400,
                                        color: '#0a53be'
                                    }}>{
                                        CurrencyFormat(getTotal(list)) + " تومان"
                                    }</span>
                                    <div style={{height: 20}}/>
                                    <label>تعداد دریافت کنندگان:</label>
                                    <span style={{
                                        display: 'block',
                                        margin: '5px 0 0 0',
                                        fontWeight: 400,
                                        color: '#0a53be'
                                    }}>{
                                        CurrencyFormat(getSelectedCount(list)) + " نفر"
                                    }</span>
                                    <div style={{height: 20}}/>
                                    <label htmlFor={titleId}>عنوان واریزی:</label>
                                    <input
                                        id={titleId}
                                        type="text"
                                        className={"form-control" + (titleErr ? ' is-invalid' : '')}
                                        value={title}
                                        onChange={e => {
                                            const t = e.currentTarget.value;
                                            setTitle(t);
                                            setTitleErr(false);
                                        }}
                                    />
                                    <div className={"invalid-feedback " + (titleErr ? 'd-block' : 'd-none')}>لطفا
                                        حداقل ۲ کاراکتر وارد کنید.
                                    </div>
                                    <div className="d-flex justify-content-end align-items-center"
                                         style={{gap: 10, marginTop: 30}}>
                                        <button className="cancel-button" onClick={props.closeHandler}>
                                            <b>انصراف</b>
                                        </button>
                                        <button className="btn-pay" onClick={saveChanges}>
                                            <b>ایجاد و دانلود خروجی</b>
                                        </button>
                                    </div>
                                </div>
                            </> :
                            <div className="reports--select-employee">
                                <div className="d-flex justify-content-between align-items-center">
                                    <label>انتخاب همکاران</label>
                                    <button className="btn-pay" onClick={() => {
                                        const lst = [...list];
                                        if (lst.findIndex((e) => e.selected) < 0) {
                                            ShowSnackbar('لطفا حداقل یک کارمند را انتخاب کنید.', 'باشه', 5000);
                                            return;
                                        }
                                        setLevel('title');
                                    }}>
                                        <b>مرحله بعدی</b>
                                    </button>
                                </div>
                                <div className="pick-device-search">
                                    <button><SearchIcon/></button>
                                    <input type="text"
                                           value={search}
                                           onChange={e => setSearch(e.currentTarget.value)}
                                           onBlur={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.remove('active')}
                                           onFocus={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.add('active')}
                                           className="f-roboto"
                                           placeholder={"جستجو براساس نام..."}
                                    />
                                </div>
                                {
                                    search.trim() === '' && list.length > 0 ?
                                        <>
                                            <hr/>
                                            <button
                                                className={"techaran-checkbox" + (isAllChecked() ? ' active' : '')}
                                                onClick={() => {
                                                    const isChecked = isAllChecked();
                                                    if (isChecked)
                                                        setList(v => {
                                                            let x = [...v];
                                                            x.forEach(r => {
                                                                r.selected = false;
                                                            });
                                                            return x;
                                                        });
                                                    else
                                                        setList(v => {
                                                            let x = [...v];
                                                            x.forEach(r => {
                                                                r.selected = true;
                                                            });
                                                            return x;
                                                        });
                                                }}>
                                                <i><CheckIcon/></i>
                                                <span>انتخاب همه</span>
                                            </button>
                                            <hr/>
                                        </> : null
                                }
                                <div className="reports--select-employee-buttons298">
                                    {
                                        list.map((e, i) =>
                                                <button key={"KJds83jns8932223974Dmd8d" + i}
                                                        className={"techaran-checkbox" + (e.selected ? ' active' : '')}
                                                        onClick={() => setList(v => {
                                                            let x = [...v];
                                                            const id = x.findIndex(r => r.id === e.id);
                                                            x[id].selected = !x[id].selected;
                                                            return x;
                                                        })}>
                                                    <i>
                                                        <CheckIcon/>
                                                    </i>
                                                    <span>
                                            {e.name}
                                                        <em>{`مبلغ ${CurrencyFormat(e.price)} تومان به حساب ${StringDigitsConvertToPersian(e.bank)}`}</em>
                                        </span>
                                                </button>
                                        )
                                    }
                                </div>
                            </div>
                    }
                </div>
            </div>
        </>
    );
};